export default __webpack_public_path__ + "static/media/01. Logo RedeTV_Official.d37e8f73.png";